'use strict';

export function JpZip(){
  $('.edit_user').on('change', '.jp-zip', function(){
    let el = $(this).attr('id').slice(0, -3);
    let zip = $(this).val();
    $.ajax({
      type: "GET",
      url: `/user/account/zip/${zip}`
    }).done( (data) => {
      if(data != null){
        $(`#${el}state`).val(data.state);
        $(`#${el}city`).val(data.city);
        $(`#${el}town`).val(data.town);
        $(`#${el}state_kana`).val(data.state_kana);
        $(`#${el}city_kana`).val(data.city_kana);
        $(`#${el}town_kana`).val(data.town_kana);
      }
    });
  });
}


// WEBPACK FOOTER //
// ./app/javascript/packs/jp_zip.js